import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./NCPWebsite/WebApp.scss";
import "./App.scss";
import "./NCPWebsite/WebSmallComponents.scss";
import "./SmallComponents.scss";
import { BrowserRouter } from "react-router-dom";
import NCLRoutes from "./components/ReusableComponents/Routes";
// import "./HomeComponents/Assests/Styles/CommonStyles.scss";
const App = () => {
  return (
    <>
      <BrowserRouter>
        <NCLRoutes />
      </BrowserRouter>
    </>
  );
};

export default App;
